import styled from 'styled-components';
import {
  Container as SemanticContainer,
  Menu as SemanticMenu,
} from 'semantic-ui-react';

export const ContentHeatmap = styled.div`
  overflow-y: auto;
`;

export const Centered = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1em 0;
`;

export const MenuFilter = styled(SemanticMenu)``;

export const MenuFilterItem = styled(MenuFilter.Item)`
 &&&&&& {
    color: ${({ theme }) => theme.color.textSecondary};
    font-size: ${({ theme }) => theme.fontSize.textHeader};
    font-family: roboto;
    padding: .6em;
    margin: 0;
    margin-right: 0.25em;
    &.active.item {
      background: rgba(240,244,251);
    }
    :hover {
      background: rgba(240,244,251);
    }
  }
`;

export const MenuContainer = styled(SemanticContainer)`
 && {
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  margin: 0 0 1em 0;
`;

export const BaseImage = styled.img`
  max-width: 100%;
  height: auto;
`;
